export const HOME_KEYS = ['percentSuccess', 'percentFailure'];

const TIE_PRIORITY = ['percentSuccess', 'percentFailure'];

const safeNumber = (v) => {
  const n = Number(v);
  return Number.isFinite(n) ? n : 0;
};

const pctOfTotal = (v, total) => (total ? (safeNumber(v) / total) * 100 : 0);

export function toDisplayPercentsExact100(decimalsByKey, keys = HOME_KEYS) {
  const decimals = keys.map((k) => safeNumber(decimalsByKey[k]));

  const sumDecimals = decimals.reduce((a, b) => a + b, 0);
  if (sumDecimals === 0) {
    return Object.fromEntries(keys.map((k) => [k, 0]));
  }

  const floors = decimals.map(Math.floor);
  let leftover = 100 - floors.reduce((a, b) => a + b, 0);

  const keyIndex = Object.fromEntries(keys.map((k, i) => [k, i]));
  const tieRank  = Object.fromEntries(TIE_PRIORITY.map((k, i) => [k, i]));

  const order = decimals
    .map((p, i) => ({
      i,
      frac: p - Math.floor(p),
      tie: tieRank[keys[i]] ?? keyIndex[keys[i]],
    }))
    .sort((a, b) => (b.frac - a.frac) || (a.tie - b.tie));

  const ints = [...floors];

  let j = 0;
  while (leftover > 0 && order.length > 0) {
    ints[order[j % order.length].i] += 1;
    leftover -= 1;
    j += 1;
  }

  return Object.fromEntries(keys.map((k, i) => [k, ints[i]]));
}

export function buildHomeBarData(operatorStats = []) {
  return operatorStats.map((op) => {
    const s = safeNumber((op.Success ?? op.success) ?? 0);
    const f = safeNumber((op.Failure ?? op.failure) ?? 0);
    const total = s + f;

    const decimalsByKey = {
      percentSuccess: pctOfTotal(s, total),
      percentFailure: pctOfTotal(f, total),
    };

    const hasData = total > 0;
    const displayByKey = hasData
      ? toDisplayPercentsExact100(decimalsByKey, HOME_KEYS)
      : undefined;

    return {
      operatorCode: op.OperatorCode ?? op.operatorCode ?? op.operator ?? '',
      operatorName: op.OperatorName ?? op.operatorName ?? op.operator ?? '',
      ...decimalsByKey,
      ...(hasData ? { __display: displayByKey } : {}), 
      hasData,
    };
  });
}

export function buildHomePieData(fileStats) {
  const success = safeNumber(fileStats?.success ?? 0);
  const failure = safeNumber(fileStats?.failure ?? 0);
  const total = success + failure;
  if (!total) {
    return { pieDecimals: [], displayMap: {} };
  }

  const decSuccess = pctOfTotal(success, total);
  const decimalsByKey = {
    percentSuccess: decSuccess,
    percentFailure: 100 - decSuccess,
  };

  const displayByKey = toDisplayPercentsExact100(decimalsByKey, HOME_KEYS);

  return {
    pieDecimals: [
      { name: 'Success', value: decimalsByKey.percentSuccess },
      { name: 'Failure', value: decimalsByKey.percentFailure },
    ],
    displayMap: {
      Success: displayByKey.percentSuccess,
      Failure: displayByKey.percentFailure,
    },
  };
}
